import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";
import { useControlContext } from "@frontend/contexts";

import {
  AutocompleteContext,
  makeAutocompleteContext,
} from "./Autocomplete.context";
import type { AutocompleteProps } from "./Autocomplete.types";

const BaseAutocompleteRoot = BaseAutocomplete.Root as <Value>(
  props: AutocompleteProps<Value> & { "data-slot"?: string },
) => JSX.Element;

export function Autocomplete<Value>({
  size,
  ...props
}: AutocompleteProps<Value>): JSX.Element {
  const inherited = useControlContext();
  const resolvedSize = size ?? inherited.size;

  return (
    <AutocompleteContext.Provider
      value={makeAutocompleteContext({ size: resolvedSize })}
    >
      <BaseAutocompleteRoot data-slot="autocomplete" {...props} />
    </AutocompleteContext.Provider>
  );
}
